module.exports = __webpack_public_path__ + "img/NewZealand.9636477a.png";